enum Mutation {
  SET_ROTATION_GROUPS = 'setRotationGroups',
  SET_UNASSIGNED_EMPLOYMENTS_LENGTH = 'setUnassignedEmploymentsLength',
}

export default Mutation;
